<template>
  <div
    class="mb-12"
    :class="$vuetify.breakpoint.name === 'lg' ? 'pr-12 pl-8' : 'px-3'">
    <v-dialog v-model="dialog.checkout" persistent max-width="400">
      <v-card class="pa-3">
        <v-card-title class="title">Peringatan !</v-card-title>
        <v-card-text>Ketika Anda mencheckout data ini Anda tidak dapat mengubah data lagi</v-card-text>
        <v-card-text>Apakah anda yakin ingin untuk mencheckout data ini ?</v-card-text>
        <v-alert 
          type="error" 
          text
          dense
          prominent
          v-show="response !== ''">
          {{ response }}
        </v-alert>
        <v-card-actions class="pb-5">
          <v-spacer></v-spacer>
          <v-btn
            small
            rounded
            width="70"
            color="#ff618a"
            elevation="0"
            :disabled="process.checkout"
            :loading="process.checkout"
            class="white--text text-capitalize"
            @click="checkoutSiswa">
            Yakin
          </v-btn>
          <v-btn
            rounded
            small
            width="70"
            elevation="0"
            class="text-capitalize"
            :disabled="process.checkout"
            @click="dialog.checkout = false">
            Tidak
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div class="mt-0 pa-7 pt-0">
      <v-stepper v-model="e1">
        <v-stepper-header class="b-s-none">
          <v-stepper-step 
            color="#ff618a"
            :complete="e1 > 1" 
            step="1">
            Tambah Siswa
          </v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step 
            color="#ff618a"
            :complete="e1 > 2" 
            step="2">
            Transaksi
          </v-stepper-step>
          <!-- <v-divider></v-divider>
          <v-stepper-step 
            step="3"
            color="#ff618a">
            Checkout
          </v-stepper-step> -->
        </v-stepper-header>
        <v-stepper-items>
          <div class="title text--secondary mb-1 mx-6">
            {{ detail.classesTitle }}
          </div>
          <div class="d-flex align-center mx-6 text--secondary">
            <div class="body-1 font-weight-bold" v-if="detail.classesDiscount > 0">
              {{
                detail.classesPrice - ((detail.classesPrice / 100) * detail.classesDiscount) | price
              }}
            </div>
            <div class="caption font-weight-bold red--text mx-1" style="text-decoration: line-through;"
              v-if="detail.classesDiscount > 0">
              {{ detail.classesPrice | price }}
            </div>
          </div>
          <div class="body-1 font-weight-bold mx-6" v-if="detail.classesDiscount < 1">
            <span v-if="detail.classesPrice > 0">
              {{ detail.classesPrice | price }}
            </span>
            <span v-else>
              Gratis
            </span>
          </div>
          <v-stepper-content step="1">
            <div class="body-1 text--secondary mb-5">
              Tambah Siswa
            </div>
            <div 
              v-if="process.run" 
              class="text-center">
              <v-skeleton-loader
                ref="skeleton"
                type="table-tbody"
                class="mx-auto">
              </v-skeleton-loader>
            </div>
            <v-simple-table 
              v-if="!process.run" 
              :fixed-header="true">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th>No</th>
                    <th>Nama</th>
                    <th>Email</th>
                    <th>Telephone</th>
                    <th>
                      <v-checkbox
                        color="cyan darken-3"
                        v-model="addAll"
                        v-on:change="addAllStudent()">
                      </v-checkbox>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="( l, index ) in list"
                    :key="index">
                    <td>{{ index+1 }}</td>
                    <td class="cyan--text text--darken-3">
                        {{ l.userFullname }}
                    </td>
                    <td>{{ l.userEmail }}</td>
                    <td>{{ l.userPhoneNumber }}</td>
                    <td>
                      <v-checkbox
                        v-model="selected"
                        color="cyan darken-3"
                        :value="l">
                      </v-checkbox>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
            <!-- <div v-for="(l, index) in list" :key="index">
              <v-checkbox
                v-model="data_user"
                :label="l.userFullname"
                :value="dataSiswa(l)">
              </v-checkbox>
            </div> -->
            <div>
              <v-btn
                color="#ff618a"
                rounded
                width="150"
                class="mt-3 white--text text-capitalize"
                :disabled="process.addStudent || selected.length < 1"
                :loading="process.addStudent"
                v-on:click="addStudent()">
                Lanjutkan
              </v-btn>
              <v-btn 
                text 
                rounded
                width="150"
                class="mt-3 ml-4 text-capitalize" 
                :disabled="process.addStudent"
                :to="`/class/${$route.params.id}/siswa`">
                Cancel
              </v-btn>
            </div>
          </v-stepper-content>
          <v-stepper-content step="2">
            <v-select
              v-model="form.Cicilan"
              :items="cicilan"
              item-text="title"
              item-value="value"
              label="Cicilan Pembayaran"
              outlined
              dense
              color="#ff618a"
              v-on:change="addPayment">
            </v-select>
            <ValidationObserver ref="observer">
              <v-row>
                <v-col cols="12" md="6">
                  <div v-if="form.Cicilan !== ''">
                    <div v-for="(l, index) in form.payment" :key="index">
                      <ValidationProvider
                        name="Harga"
                        rules="required|min_10000:10000|max_classPrice:100000000"
                        v-slot="{ errors }">
                        <v-currency-field
                          outlined
                          dense
                          color="#ff618a"
                          type="number"
                          label="Harga"
                          :prefix="`Rp`"
                          v-model="form.payment[index].price"
                          :error-messages="errors"
                          required
                        />
                      </ValidationProvider>
                    </div>
                  </div>
                </v-col>
                <v-col md="6">
                  <div v-if="form.Cicilan !== ''">
                    <div v-for="(l, index) in form.payment" :key="index">
                      <ValidationProvider
                          :name="due_date[index]"
                          rules="required"
                          v-slot="{ errors }">
                          <v-menu
                            ref="menustart"
                            v-model="due_date[index]"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            lazy
                            class="z-my"
                            transition="scale-transition"
                            offset-y
                            full-width
                            min-width="290px">
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                v-model="form.payment[index].date"
                                label="Tanggal Pembayaran"
                                prepend-inner-icon="mdi-calendar"
                                readonly
                                outlined
                                dense
                                style="margin-bottom: 25px; !important"
                                :disabled="index !== 0 ? form.payment[index-1].date === '' : false"
                                color="#ff618a"
                                hide-details
                                v-on="on"
                                :error-messages="errors"
                                required>
                              </v-text-field>
                            </template>
                            <v-date-picker 
                              v-model="form.payment[index].date" 
                              :min="index === 0 ? reminder : form.payment[index-1].date"
                              :max="endDate"
                              color="#ff618a"
                              v-on:change="resetDate(index)"
                              @input="due_date[index] = false">
                            </v-date-picker>
                          </v-menu>
                      </ValidationProvider>
                    </div>
                  </div>
                </v-col>
              </v-row>
            </ValidationObserver>
            <v-row align="center" v-if="form.Cicilan !== ''">
              <v-col cols="12" md="6">
                <div
                  class="pa-2 d-flex align-center"
                  :class="$vuetify.breakpoint.name === 'xs' ||$vuetify.breakpoint.name === 'sm' ? 'px-0' : 'px-0'">
                  <div class="body-1 text--secondary font-weight-bold">
                    Total Pembayaran
                  </div>
                  <div 
                  class="title text--secondary ml-auto"
                  :style="$vuetify.breakpoint.name === 'xs' || $vuetify.breakpoint.name === 'sm' ? 'margin-right: 0px' : 'margin-right: 105px'">
                  </div>
                </div>
                <div
                  class="pa-2 d-flex align-center"
                  :class="$vuetify.breakpoint.name === 'xs' ||$vuetify.breakpoint.name === 'sm' ? 'px-0' : 'px-0'">
                  <div class="body-1 text--secondary font-weight-bold">
                    Total Input Data
                  </div>
                  <div 
                  class="title text--secondary ml-auto"
                  :style="$vuetify.breakpoint.name === 'xs' || $vuetify.breakpoint.name === 'sm' ? 'margin-right: 0px' : 'margin-right: 105px'">
                  </div>
                </div>
                <div
                  class="pa-2 d-flex align-center"
                  :class="$vuetify.breakpoint.name === 'xs' ||$vuetify.breakpoint.name === 'sm' ? 'px-0' : 'px-0'">
                  <div class="body-1 text--secondary font-weight-bold">
                    Input Data <span v-if="detail.price < totalCicilan">Kelebihan</span> <span v-if="detail.price >= totalCicilan">Kurang</span>
                  </div>
                  <div 
                  class="title text--secondary ml-auto"
                  :style="$vuetify.breakpoint.name === 'xs' || $vuetify.breakpoint.name === 'sm' ? 'margin-right: 0px' : 'margin-right: 105px'">
                  </div>
                </div>
              </v-col>
              <v-col md="6">
                <div class="text-right pa-2">
                  <span v-if="detail.price > 0">
                    {{ detail.price | price }}
                  </span>
                  <span v-else>
                    Gratis
                  </span>
                </div>
                <div class="text-right pa-2">
                  {{ totalCicilan | price }}
                </div>
                <div class="text-right pa-2">
                  <span v-if="detail.price < totalCicilan">
                    + {{ totalCicilan - detail.price | price }}
                  </span> 
                  <span v-if="detail.price >= totalCicilan">
                    - {{ detail.price - totalCicilan | price }}
                  </span>
                </div>
              </v-col>
            </v-row>
            <v-btn
              color="#ff618a"
              rounded
              width="150"
              :disabled="totalCicilan !== detail.price"
              @click="toCheckoutSiswa"
              class="mt-3 white--text text-capitalize">
              Checkout
            </v-btn>

            <v-btn 
              text 
              width="150"
              rounded
              class="mt-3 text-capitalize"
              @click="changeStep(parseInt(e1) - parseInt(1))">
              Cancel
            </v-btn>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper> 
    </div>
  </div>
</template>

<script>
import { get, post, put, destroy } from "../../../service/Axios";
import qs from "querystring";
export default {
  data() {
    return {
      e1: 1,
      dialog: {
        checkout: false
      },
      selected: [],
      data_user: [],
      data_price_checkout: [],
      addAll: false,
      list: [],
      cicilan: [],
      detail: {},
      data_price: [],
      endDate: '',
      due_date:[],
      form: {
        Inputan: "",
        Cicilan: "",
        studentPrice: [],
        payment: []
      },
      process: {
        run: false,
        addStudent: false,
        checkout: false
      },
      response: ''
    };
  },
  mounted() {
    this.fetchDetailClass()
    this.fetch()
    if (this.$route.query.step) {
      this.e1 = this.$route.query.step;
    } else {
      this.e1 = 1;
    }
  },
  computed:{
    totalCicilan(){
      let total = 0
      for(var i in this.form.payment) { 
        total += this.form.payment[i].price;
      }
      return total
    },
    reminder () {
      let now = new Date(),
          next = new Date(now)
      next.setDate(now.getDate())
      return next.toISOString().substr(0, 10)
    }
  },
  methods: {
    async fetchDetailClass() {
      this.process.run = true;
      await get(`/api/internal/class/detail/${this.$route.params.id}`).then(
        (response) => {
          let res = response.data;
          if (response.data.code === 200) {
            this.detail = response.data.data;
            if (this.detail.classesDiscount < 1) {
              this.detail.price = this.detail.classesPrice
            } else {
              this.detail.price = this.detail.classesPrice - ((this.detail.classesPrice / 100) * this.detail.classesDiscount)
            }
            this.endDate = this.$callbackdate(this.detail.classesEndDatetime)
            this.cicilan = response.data.data.classesInstallment;
            if (this.detail.classesIsCheckout === 'yes') {
              window.location = `/class/${this.$route.params.id}`
            }
          }
        }
      );
    },
    async fetch(p) {
      this.process.run = true;
      await get(`api/internal/users/list`, {
        params: {
          search: "user_roles:user",
          classId: this.$route.params.id,
          limit: 100000000000
        },
      }).then((response) => {
        let res = response.data;
        if (res.code === 200) {
          this.process.run = false;
          this.list = res.data;
          for (let i in this.list) {
            if (this.list[i].userIsInclass === 'yes') {
              this.selected.push(
                this.list[i]
              )
            }
          }
          this.pagination = res.pagination;
        }
      });
    },
    addPayment() {
      this.form.payment = []
      for (let i = 1; i <= this.form.Cicilan; i++) {
        this.form.payment.push({
          price: 0,
          date: ''
        })
      }
    },
    resetDate(index) {
      for (let i in this.form.payment) {
        if (index < i) {
          this.form.payment[i].date = ''
        }
      }
    },
    changeStep(data) {
      this.e1 = data;
      this.$router.replace({ query: { step: data } });
    },
    addStudent () {
      this.data_user = []
      for (let i in this.selected) {
        this.data_user.push(
          {
            user_fullname: this.selected[i].userFullname,
            _id: this.selected[i].id,
            user_token_fcm: this.selected[i].userTokenFcm,
            user_token_fcm_mobile: '',
            user_phone_number : this.selected[i].userPhoneNumber,
            user_email : this.selected[i].userEmail,
            user_roles: this.selected[i].userRoles,
          }
        )
      }
      this.createsSiswa()
    },
    addAllStudent() {
      this.selected = []
      if (this.addAll === true) {
        for (let i in this.list) {
          this.selected.push(
            this.list[i]
          )
        }
      } else {
        this.selected = []
      }
    },
    async createsSiswa() {
      this.process.addStudent = true;
      await post(
        `api/internal/student/in/class/create/${this.$route.params.id}`,
        {
          data: {data_user : this.data_user},
        }
      ).then((response) => {
        let res = response.data;
        if (res.code === 200) {
          this.e1 = 2;
          this.$router.replace({ query: { step: 2 } });
        } else {
          this.process.addStudent = false;
          this.response = res.msg;
        }
      });
    },
    async toCheckoutSiswa() {
      this.response = "";
      const isValid = await this.$refs.observer.validate();
      if (isValid) {
        for (let i in this.selected) {
          this.data_price_checkout.push(
            {
              user_fullname: this.selected[i].userFullname,
              _id: this.selected[i].id,
              user_token_fcm: this.selected[i].userTokenFcm,
              user_token_fcm_mobile: '',
              user_phone_number : this.selected[i].userPhoneNumber,
              user_email : this.selected[i].userEmail,
              user_roles: this.selected[i].userRoles,
            }
          )
        }
        this.dialog.checkout = true
        this.response = ''
      }
    },
    async checkoutSiswa() {
      this.process.checkout = true;
      await post(
        `api/internal/student/checkout/${this.$route.params.id}`,
        {
          data: {
            classId:this.$route.params.id,
            installment_class: this.form.Cicilan,
            data_price: this.form.payment,
            data_user : this.data_price_checkout
          },
        }
      ).then((response) => {
        let res = response.data;
        if (res.code === 200) {
          this.dialog.checkout = false
          window.location = `/class/${this.$route.params.id}`
        } else {
          this.process.checkout = false;
          this.response = res.msg;
        }
      });
    },
  },
};
</script>

<style>
  .b-s-none {
    box-shadow: none !important;
  }
</style>
